import React from 'react';
import { SurveyCGType, DestinationCGType } from '@/types/graphql/root';
import MemoSaveBottomBar from '@/app/ui/trip/memo-save-bottom-bar';
import DestMoveAndModifyInTripBottomBar from '@/app/ui/trip/dest-move-and-modify-in-trip-bottom-bar';
import CopyTripButtonBottomBar from '@/app/ui/trip/copy-trip-button-bottom-bar';
import {
  ITINERARY_HEIGHT_MODE_CONDITIONS,
  ItineraryHeightModeType,
  TRIP_CONDITIONS,
  TripModeType,
} from '@/app/ui/trip/client-trip-page';

export interface TripBottomBarProps {
  mode: TripModeType;
  trip: SurveyCGType | null;
  isEmbedded: boolean;
  isValidCopyTrip: boolean;
  itineraryHeightMode: ItineraryHeightModeType;
  selectedDestIdList: string[];
  destinations: DestinationCGType[];
  memoDictionary: { [key: string]: string };
  setDestinations: React.Dispatch<React.SetStateAction<DestinationCGType[]>>;
  onClickCopyTrip: (tripId: string, title: string) => void;
  onClickReplaceDestination: (dest: DestinationCGType) => Promise<void>;
  setSelectDayForMoveDestVisible: React.Dispatch<React.SetStateAction<boolean>>;
  tripId: string | null;
  customNameOrTitleWithCities: string;
}

export default function TripBottomBar({
  mode,
  trip,
  isEmbedded,
  isValidCopyTrip,
  itineraryHeightMode,
  selectedDestIdList,
  destinations,
  memoDictionary,
  setDestinations,
  onClickCopyTrip,
  onClickReplaceDestination,
  setSelectDayForMoveDestVisible,
  tripId,
  customNameOrTitleWithCities,
}: TripBottomBarProps) {
  if (trip && TRIP_CONDITIONS.IS_MEMO_MODE(mode)) {
    return (
      <MemoSaveBottomBar
        tripId={trip.id}
        destinations={destinations}
        setDestinations={setDestinations}
        memoDictionary={memoDictionary}
      />
    );
  }

  if (TRIP_CONDITIONS.IS_EDIT_MODE(mode)) {
    return (
      <DestMoveAndModifyInTripBottomBar
        selectedDestIdList={selectedDestIdList}
        destinations={destinations}
        onClickReplaceDestinationInDestSlot={onClickReplaceDestination}
        setSelectDayForMoveDestVisible={setSelectDayForMoveDestVisible}
      />
    );
  }

  if (
    isValidCopyTrip &&
    !ITINERARY_HEIGHT_MODE_CONDITIONS.IS_MINIMALIZE(itineraryHeightMode) &&
    trip?.isOwn === false &&
    trip?.isCoEdit === null &&
    !isEmbedded
  ) {
    return (
      <CopyTripButtonBottomBar
        onClickCopyTrip={() => {
          if (tripId) {
            onClickCopyTrip(tripId, customNameOrTitleWithCities);
          }
        }}
      />
    );
  }

  return null;
}
